export class TipoEstimativaConstants {
  static ID_TIPO_ESTIMATIVA_PROJETO: number = 1;
  static ID_TIPO_ESTIMATIVA_BODYSHOP: number = 2;
  static ID_TIPO_ESTIMATIVA_DELIVERY: number = 3;
}
export class PerfilConstants {
  static ID_PERFIL_ADMINISTRADOR: number = 1;
  static ID_PERFIL_DELIVERY: number = 2;
  static ID_PERFIL_RH: number = 3;
  static ID_PERFIL_SOLUTION: number = 4;
}
export class EstimativaStatusConstants {
  static ID_ESTIMATIVA_ELABORACAO = 1;
  static ID_ESTIMATIVA_APROVADA = 2;
  static ID_ESTIMATIVA_REPROVADA = 3;
  static ID_ESTIMATIVA_EM_APROVACAO = 4;
  static ID_ESTIMATIVA_DESCARTADA = 5;
}

export class ParametrosEspecificosConstants {
  static ID_P_ADMINISTRATIVO = 1;
  static ID_P_COMISSAO = 2;
  static ID_P_IMPOSTOS = 3;
  static ID_P_INVESTIMENTO = 4;
  static ID_P_MARGEMLIQUIDA = 5;
  static ID_P_PROVISAORISCO = 6;
  static ID_P_VALORHORACLIENTEMIN = 7;
  static ID_P_VALORHORACLIENTEMAX = 8;
  static ID_FP_INICIOPLANEJA = 9;
  static ID_FP_ESPECFUNC = 10;
  static ID_FP_ESPECTECNICA = 11;
  static ID_FP_ACEITEINTERNO = 12;
  static ID_FP_TESTEINTEGRA = 13;
  static ID_FP_HOMOLOGACERT = 14;
  static ID_FP_IMPLANTA = 15;
  static ID_FP_POSIMPLANTA = 16;
  static ID_FP_DOCCMMI = 17;
  static ID_FP_GESTAOINFORMA = 18;
  static ID_FP_RISCOTECNICO = 19;
  static ID_FP_RISCO = 20;
  static ID_BS_ADMINISTRATIVO = 21;
  static ID_BS_COMISSAO = 22;
  static ID_BS_IMPOSTOS = 23;
  static ID_BS_INVESTIMENTO = 24;
  static ID_BS_MARGEMLIQUIDA = 25;
  static ID_S_IDTIPOCONTRATOPADRAO = 26;
  static ID_S_IDTIPOENCARGOPADRAO = 27;

  static ID_PC_ADMINISTRATIVOPARC = 29;
  static ID_PC_COMISSAOPARC = 30;
  static ID_PC_IMPOSTOPARC = 31;
  static ID_PC_INVESTIMENTOPARC = 32;
  static ID_PC_MARGEMLIQUIDAPARC = 33;
  static ID_PC_IDTIPOCONTRATOPADRAOPARC = 26;
  static ID_PC_IDTIPOENCARGOPADRAOPARC = 27;

  static ID_P_LIDERANCA = 34;
  static ID_BS_LIDERANCA = 35;
  static ID_BS_PROVISAO = 37;
}

export class CargoSenioridadeConstants {
  static ID_JUNIOR: number = 1;
  static ID_PLENO: number = 2;
  static ID_SENIOR: number = 3;
  static ID_ESPECIALISTA: number = 4;
}
